import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectFoundProcess = createSelector(
  [selectLandingState],
  ({ foundProcess }) => foundProcess
)
